export default "__VITE_ASSET__f6666f28__"